/* eslint-disable import/no-cycle */
import { all, takeLatest } from 'redux-saga/effects';
import { AppTypes } from './AppRedux';
import { AuthTypes } from './AuthRedux';
import { PayTypes } from './PayRedux';
import { ReceiptTypes } from './ReceiptRedux';
import { PromotionTypes } from './PromotionRedux';
import { OrderTypes } from './OrderRedux';
import { startup } from './AppSaga';
import { getGeoCurrentLocation, login, logout } from './AuthSaga';
import {
  loadPaymentMethods,
  loadTicket,
  makePayment,
  deleteCard,
  deleteTicket,
  setDefaultPaymentMethod,
  updateSelectedItem,
  applyPromotion,
  applyOfferDiscount,
  loadCurrentTicket,
  loadRewardLevels,
  loadLoyaltyPoints,
  setOptInProgram,
  deleteLoyaltyPoint,
  loadLoyaltyAutoOffers,
  setActivateOffer,
  setDeactivateOffer,
  setRegistToken,
  createTicket
} from './PaySaga';
import { loadReceipts, loadCurrentReceipt } from './ReceiptSaga';
import { loadPromotions } from './PromotionSaga';
import { loadMenuItems, sendOrder, initializeCart } from './OrderSaga';

export default function* root() {
  yield all([takeLatest(AppTypes.STARTUP, startup)]);
  yield all([takeLatest(AuthTypes.GET_GEO_CURRENT_LOCATION, getGeoCurrentLocation)]);
  yield all([takeLatest(AuthTypes.LOGIN, login)]);
  yield all([takeLatest(AuthTypes.LOGOUT, logout)]);
  yield all([takeLatest(PayTypes.LOAD_TICKET, loadTicket)]);
  yield all([takeLatest(PayTypes.LOAD_PAYMENT_METHODS, loadPaymentMethods)]);
  yield all([
    takeLatest(PayTypes.SET_DEFAULT_PAYMENT_METHOD, setDefaultPaymentMethod),
  ]);
  yield all([
    takeLatest(PayTypes.SET_ACTIVATE_OFFER, setActivateOffer),
  ]);
  yield all([
    takeLatest(PayTypes.SET_DEACTIVATE_OFFER, setDeactivateOffer),
  ]);
  yield all([
    takeLatest(PayTypes.SET_REGIST_TOKEN, setRegistToken),
  ]);
  yield all([
    takeLatest(PayTypes.LOAD_LOYALTY_AUTO_OFFERS, loadLoyaltyAutoOffers),
  ]);
  yield all([
    takeLatest(PayTypes.LOAD_REWARD_LEVELS, loadRewardLevels),
  ]);
  yield all([
    takeLatest(PayTypes.LOAD_LOYALTY_POINTS, loadLoyaltyPoints),
  ]);
  yield all([takeLatest(PayTypes.SET_OPT_IN_PROGRAM, setOptInProgram)]);
  yield all([takeLatest(PayTypes.DELETE_LOYALTY_POINT, deleteLoyaltyPoint)]);
  yield all([takeLatest(PayTypes.MAKE_PAYMENT, makePayment)]);
  yield all([takeLatest(PayTypes.DELETE_CARD, deleteCard)]);
  yield all([takeLatest(PayTypes.DELETE_TICKET, deleteTicket)]);
  yield all([takeLatest(PayTypes.UPDATE_SELECTED_ITEM, updateSelectedItem)]);
  yield all([takeLatest(PayTypes.APPLY_PROMOTION, applyPromotion)]);
  yield all([takeLatest(PayTypes.APPLY_OFFER_DISCOUNT, applyOfferDiscount)]);
  yield all([takeLatest(PayTypes.LOAD_CURRENT_TICKET, loadCurrentTicket)]);
  yield all([takeLatest(ReceiptTypes.LOAD_RECEIPTS, loadReceipts)]);
  yield all([
    takeLatest(ReceiptTypes.LOAD_CURRENT_RECEIPT, loadCurrentReceipt),
  ]);
  yield all([takeLatest(OrderTypes.LOAD_MENU_ITEMS, loadMenuItems)]);
  yield all([takeLatest(OrderTypes.SEND_ORDER, sendOrder)]);
  yield all([takeLatest(OrderTypes.INITIALIZE_CART, initializeCart)]);
  yield all([takeLatest(PromotionTypes.LOAD_PROMOTIONS, loadPromotions)]);
  yield all([takeLatest(PayTypes.CREATE_TICKET, createTicket)]);
}
